import dayjs from "dayjs";
import { BankAccountCurrency } from "../collections/BankAccounts/enum";
import { convertCurrency } from "./convertCurrency";
import { TransactionType } from "@root/api.types";
export const splitTransactionsByDay = (transactions) => {
    const transactionsByDay = {};
    transactions.forEach((transaction) => {
        const dateKey = dayjs(transaction.transactionDate).format("YYYY.MM.DD");
        if (!transactionsByDay[dateKey]) {
            transactionsByDay[dateKey] = [];
        }
        if (transaction.type === TransactionType.income ||
            transaction.type === TransactionType.expense) {
            transactionsByDay[dateKey].push(transaction);
        }
    });
    // Sort the keys in ascending order
    const sortedKeys = Object.keys(transactionsByDay).sort();
    // Create a new object with sorted keys
    const sortedTransactionsByDay = {};
    sortedKeys.forEach((key) => {
        sortedTransactionsByDay[key] = transactionsByDay[key];
    });
    return sortedTransactionsByDay;
};
export const splitTransactionsByCompany = (transactions) => {
    const splitTransactions = {};
    transactions.forEach((transaction) => {
        var _a;
        const { amount, company, sourceBankAccount, destinationBankAccount, type } = transaction;
        const companyName = company.name;
        if (type === TransactionType.income || type === TransactionType.expense) {
            if (!splitTransactions[companyName]) {
                splitTransactions[companyName] = {
                    companyName,
                    totalTransactionCount: 0,
                    totalTransactionAmount: 0,
                };
            }
            splitTransactions[companyName].totalTransactionCount++;
            splitTransactions[companyName].totalTransactionAmount += convertCurrency((_a = sourceBankAccount === null || sourceBankAccount === void 0 ? void 0 : sourceBankAccount.currency) !== null && _a !== void 0 ? _a : destinationBankAccount === null || destinationBankAccount === void 0 ? void 0 : destinationBankAccount.currency, amount, BankAccountCurrency.RON);
        }
    });
    return Object.values(splitTransactions);
};
